import React from 'react'

import  Inicio  from '../components/Inicio';
import { HomeSnow } from '../components/BackgHome';

const Home = () => {

    return (

        <>
        <HomeSnow />
        <Inicio/>
        
        </>
    
    );
}
export default Home;